import { useMemo } from "react";
import { MRT_ColumnDef } from "mantine-react-table";
import { Badge } from "@mantine/core";
import { getRegtankColor } from "../../../../Utils/getRegtankDetails";
import { RegtankLivenessFHStatusEnum } from "@funded-here-interface/common/src/constant/enum";
import type { RegtankLivenessData } from "../Regtank.types";

/**
 * Column definitions for individual liveness table
 * Used for displaying liveness verification status for individual users
 */
export const useIndividualLivenessColumns = () => {
  return useMemo<MRT_ColumnDef<RegtankLivenessData>[]>(
    () => [
      {
        accessorKey: "verificationStatus",
        header: "Latest Status",
        Cell: ({ cell }) => {
          const label = getRegtankColor(
            cell.getValue<RegtankLivenessFHStatusEnum>()
          );
          if (label === "gray") {
            return null;
          } else {
            return (
              <Badge
                color={getRegtankColor(
                  cell.getValue<RegtankLivenessFHStatusEnum>()
                )}
              >
                {cell.getValue<RegtankLivenessFHStatusEnum>()}
              </Badge>
            );
          }
        },
      },
      {
        accessorKey: "lastAttemptDate",
        header: "Last Attempt On",
      },
    ],
    []
  );
};
